/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:12:04 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

// import { AppBarSpacer } from "theme/template/components/AppBar";
// import { COLORSCHEME } from "theme/styles";
import Box from "@mui/material/Box";

export const MainPageContainer = (props: any) => {
  return (
    <Box component="main" className={props.className}>
      {/* Using this custom component for some extra spacing so content can appear below App Bar */}
      {/*<AppBarSpacer sx={{ backgroundColor: COLORSCHEME.background }} />*/}
      {/* Space for the AppBar that pushes content below it */}
      {props.children}
    </Box>
  );
};
